import api from '../socket';

export const checkPermission = url => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'CheckUserPermissions',
        options: {
            url,
            permissions: ['r'],
        },
    }).then(response => response).catch(error => error)
);

export const getUserPermissions = (urls, permissions) => api.send({
    api: 'module',
    module: 'App',
    classMethod: 'GetUserPermissions',
    options: {
        urls,
        permissions,
    },
});



// WEBPACK FOOTER //
// ./src/modules/App/requests/check_permission_request.js